<template>
    <div class="dashboard-calendar" :class="[context, $store.getters.getCalendarMode, {'placement': $store.getters.isPlacementModeActive}]" :style="{'position': 'relative', 'top': offset_top + 'px'}">

        <div class="panel-head-section">
            <h1 class="standard-title">Daily Calendar: {{labels.month_name}}<span v-if="is_loading || is_processing" class="calendar-main-loader" v-html="is_loading ? 'loading...' : 'processing...'"></span></h1>
            <div>

                <div class="standard-button compact calendar" v-if="context === 'dashboard'" @click="openCalendarModal">View planner</div>

                <div class="video-being-placed" v-if="$store.getters.isPlacementModeActive" @click="$store.commit('resetVideoPlacement')">
                    <span>Choose a day for this video ↴</span>
                </div>

                <div class="options">
                    <span>Mode: </span>
                    <div>
                        <span>
                            <input :id="'drills-'+context" type="radio" v-model="calendar_mode" value="drills">
                            <label :for="'drills-'+context">Completions</label>
                        </span>
                        <span>
                            <input :id="'schedule-'+context" type="radio" v-model="calendar_mode" value="schedule">
                            <label :for="'schedule-'+context">Schedule</label>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="calendar-main">
            <div class="background-month-title" v-if="!is_loading">
                <h2>{{labels.month_name}}</h2>
            </div>
            <table>
                <thead>
                    <tr>
                        <th class="monday"><span>mon</span></th>
                        <th class="tuesday"><span>tues</span></th>
                        <th class="wednesday"><span>wed</span></th>
                        <th class="thursday"><span>thurs</span></th>
                        <th class="friday"><span>fri</span></th>
                        <th class="saturday"><span>sat</span></th>
                        <th class="sunday"><span>sun</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in calendar_rows">
                        <td
                            v-for="day in row"
                            :class="{
                                'foreign-month': day.foreign_month,
                                today: day.today,
                                future: day.future,
                                completed: day.completed,
                                dropped: day.date === $store.getters.getCalendarVideoBeingPlaced.dropped_on,
                                'has-video': day.has_video,
                                'has-drill': !day.has_video
                            }"
                        >
                            <div class="day-cell-inner"
                                :class="{'has-tooltip': day.has_video && $store.getters.getCalendarMode === 'schedule' && !$store.getters.isPlacementModeActive, 'use-data-attr': day.has_video && $store.getters.getCalendarMode === 'schedule' && !$store.getters.isPlacementModeActive}"
                                :data-tooltip="day.has_video ? day.placed_video_data.title : null"
                                @click="clickDay(day)"
                            >
                                <span class="completed" v-if="day.completed"></span>

                                <div class="has-drill" v-if="$store.getters.getCalendarMode === 'schedule' && !day.has_video">
                                    <img src="/build/assets/standard-drill-icon.png">
                                    <span></span>
                                </div>

                                <div class="has-video" v-if="$store.getters.getCalendarMode === 'schedule' && day.has_video">
                                    <img src="/build/assets/film-icon.png">
                                    <span>{{ day.placed_video_data.duration }}</span>
                                </div>
                            </div>
                            <span>{{day.day}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="panel-foot-section">
            <div class="calendar-controls">

                <button class="calendar-navigation" :class="{disabled: navigation.previous.disabled[$store.getters.getCalendarMode], loading: is_loading}" @click="loadMonth(navigation.previous.month,navigation.previous.year)"><span class="loader">wait...</span><span class="month-label">{{navigation.previous.monthName}}</span></button>

                <div class="calendar-text-block scheduler-foot" v-if="!is_loading && $store.getters.getCalendarMode === 'schedule'">
                    <div>
                        <div class="keys">
                            <small><img src="/build/assets/film-icon.png" alt="Library video">: library video</small>
                            <small class="mt025"><img src="/build/assets/standard-drill-icon.png" alt="10 minute drill"><span style="margin-right:0.5em">: 10 minute book moves on video</span> <i class="fa fa-video"></i></small>
                        </div>
                        <div class="options" :class="{disabled: !this.navigation.show_options}">
                            <a href="#" @click.prevent="clearThisMonth" title="Clear scheduled workouts this month">Clear this month</a>
                            <a href="#" @click.prevent="clearAllFuture" title="Clear ALL future scheduled workouts">Clear ALL future</a>
                            <a href="#" @click.prevent="cloneLastMonth" title="Clone last month's schedule">Clone last month</a>
                            <a href="#" @click.prevent="alternateBookMoves" title="Alternate book moves"> Alternate moves</a>
                        </div>
                    </div>
                </div>
                <div class="calendar-text-block" v-if="!is_loading && $store.getters.getCalendarMode === 'drills'">
                    <small>{{labels.consistency}}</small>
                    <small>{{labels.days_completed}}</small>
                </div>

                <button class="calendar-navigation" :class="{disabled: navigation.next.disabled[$store.getters.getCalendarMode], loading: is_loading}" @click="loadMonth(navigation.next.month,navigation.next.year)"><span class="loader">wait...</span><span class="month-label">{{navigation.next.monthName}}</span></button>

            </div>
        </div>

    </div>

    <teleport to="body" v-if="placed_video">
        <div class="iwd-modal video-info-modal">
            <div class="modal-inner">
                <button class="close-modal" @click="closeModal()"></button>
                <div class="modal-media-el">
                    <img :src="placed_video.thumbnail" :alt="placed_video.title" style="display: block">
                </div>
                <div>
                    <h6 class="mt150">{{ placed_video.title }}</h6>
                    <h6>{{ placed_video.duration }} minutes</h6>
                    <ul class="prop-list">
                        <li v-for="prop in placed_video.props" class="prop-label" :class="prop"></li>
                    </ul>
                </div>
                <div class="fxrbc mt150 modal-options">
                    <a v-if="placed_video.editable" class="delete" href="#" @click.prevent="deleteOrReplacePlacedVideo(placed_video.placement_id)">{{ default_to_book ? 'Replace with book routine' : 'Replace routine' }}</a>
                    <a v-if="placed_video.editable" class="move" href="#" @click.prevent="movePlacedVideo(placed_video)">Move to another day</a>
                </div>
            </div>
        </div>
    </teleport>

</template>

<script>

var emitter = require('tiny-emitter/instance');

export default {
	props: {
	    offset_top: Number,
        context: String
    },
	data(){
		return {
			is_loading: true,
            is_processing: false,
            month: null,
            year: null,
            calendar_rows: [],
            labels: {},
            navigation: {
				previous: {
					disabled: {
						drills: true,
                        schedule: true
                    }
                },
                next: {
					disabled: {
						drills: true,
                        schedule: true
                    }
                },
                show_options: false
            },
            placed_video: false,
            default_to_book: false
        }
    },
    mounted()
    {
		this.createSkeleton();

        emitter.on('calendarModalClosed', () => {
            this.getData(this.month, this.year);
        });
        // when favourite is deleted it also needs to be removed from placement on calendar (if it is placed) so needs call to refresh
        // only if calendar has been inialized (I think just check this with is month/year is null or not)
        emitter.on('workoutLibraryFavouriteDeleted', () => {
        	if(this.month && this.year){
        		this.getData(this.month, this.year);
            }
        });
    },
    methods: {
		createSkeleton(){
			let calendar_days = [];
		    for(let i=0;i<42;i++){
		    	calendar_days.push({});
            }

            const perChunk     = 7;
            this.calendar_rows = calendar_days.reduce((resultArray, item, index) => {

                const chunkIndex = Math.floor(index/perChunk);

                if(!resultArray[chunkIndex]) {
                    resultArray[chunkIndex] = [];
                }
                resultArray[chunkIndex].push(item);
                return resultArray;
            }, []);
        },
        loadMonth(m,y){
			this.is_loading = true;
			this.createSkeleton();
            this.getData(m,y);
        },
		getData(m,y)
        {
            return new Promise((resolve, reject) => {

                axios.get('/api/user/get-calendar-data/'+m+'/'+y).then((response)=>{

                    this.setMonth(response.data.calendar_data.month, response.data.calendar_data.year);
                    this.applyMonth(response.data.calendar_data);
                    this.default_to_book = response.data.calendar_data.default_to_book;

                    resolve(true);

                }).catch((e) => {
                    if(e.response){
                        console.log(e.response.data.message);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                });
            });
        },
        setMonth(month, year)
        {
            this.month = month;
            this.year = year;
        },
        applyMonth(calendar_data)
        {
        	this.calendar_rows = calendar_data.calendar_rows;
        	this.navigation = calendar_data.navigation;
            this.labels = calendar_data.labels;
            // this.assignation_data = calendar_data.assignation_data;
            this.$store.commit('syncPlacedVideosList', calendar_data.placed_vimeo_ids_list);
        	this.is_loading = false;
        },
		clickDay(day)
        {
        	if(this.$store.getters.getCalendarMode !== 'schedule')
            {
            	return false;
            }

        	if(this.$store.getters.isPlacementModeActive)
            {
                this.dropVideo(day);

            }else if(day.has_video) {
        		this.showPlacedVideoInfo(day);
            }
        },
        showPlacedVideoInfo(day)
        {
        	if(this.$store.getters.getCalendarMode !== 'schedule' || !day.has_video)
            {
                return false;
            }
        	let data = day.placed_video_data;

        	data.editable = (day.today || day.future) && this.context !== 'dashboard';

            this.placed_video = data;
        },
        closeModal()
        {
            this.placed_video = false;
        },
        deleteOrReplacePlacedVideo(placement_id)
        {
        	this.is_processing = true;

            this.placed_video = false;

            axios.delete(`/api/user/delete-library-video-from-calendar/${this.month}/${this.year}/` + placement_id).then((response)=>{

                if(response.data.success)
                {
                    this.getData(this.month, this.year).then(()=>{
                    	this.$store.commit('syncPlacedVideosList', response.data.placed_vimeo_ids_list);
                        this.$store.commit('resetVideoPlacement');
                        this.is_processing = false;
                    });
                    return true;
                }
                alert('System error');
                this.is_processing = false;
                return false;

            }).catch((e) => {
                if(e.response){
                    console.log(e.response.data.message);
                }else {
                    throw new Error('An error occurred connecting with the server.');
                }
                this.is_processing = false;
            });
        },
        movePlacedVideo(data)
        {
        	this.placed_video = false;

        	data.video_data = {
        		title: data.title
            };

        	data.pending_deletion = data.placement_id;

        	this.$store.dispatch('placingVideo', data);

            if(!this.$store.getters.isDesktopScreen)
            {
                $("html, body").animate({ scrollTop: 0 });
            }
        },
        dropVideo(day_data)
        {
        	if(day_data.today || day_data.future)
            {
            	this.is_processing = true;

            	this.$store.commit('dropVideoOnCalendarDay', day_data.date);

            	const start_time = (new Date()).getTime();

                axios.post(`/api/user/place-library-video-on-calendar/${this.month}/${this.year}`, {data: this.$store.getters.getCalendarVideoBeingPlaced}).then((response)=>{

                	if(response.data.success)
                    {
                        this.getData(this.month, this.year).then(()=>{
	                        this.$store.commit('syncPlacedVideosList', response.data.placed_vimeo_ids_list);
	                        this.$store.commit('resetVideoPlacement');
                            this.is_processing = false;
                        });
	                    return true;
                    }
                	alert('Invalid placement.');
                	this.is_processing = false;
                	return false;

                }).catch((e) => {
                    if(e.response){
                        console.log(e.response.data.message);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                    this.is_processing = false;
                });
            }
        	return false;
        },
        clearThisMonth()
        {
            if(confirm("This will remove all the workouts you've scheduled in the shown month. Are you sure?"))
            {
            	this.is_processing = true;

                axios.delete(`/api/user/clear-this-month/${this.month}/${this.year}`).then((response)=>{

                    if(response.data.success)
                    {
                        this.getData(this.month, this.year).then(()=>{
                            this.$store.commit('syncPlacedVideosList', response.data.placed_vimeo_ids_list);
                            this.$store.commit('resetVideoPlacement');
                            this.is_processing = false;
                        });
                        return true;
                    }
                    alert('The server could not process this request');
                    this.is_processing = false;
                    return false;

                }).catch((e) => {
                    if(e.response){
                        console.log(e.response.data.message);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                    this.is_processing = false;
                });
            }
        },
        clearAllFuture()
        {
            if(confirm("You're about to clear all of your scheduled workouts for the shown month, as well as all future months. This can't be undone. Are you sure you want to continue?"))
            {
            	this.is_processing = true;

                axios.delete(`/api/user/clear-all-future/${this.month}/${this.year}`).then((response)=>{

                    if(response.data.success)
                    {
                        this.getData(this.month, this.year).then(()=>{
                            this.$store.commit('syncPlacedVideosList', response.data.placed_vimeo_ids_list);
                            this.$store.commit('resetVideoPlacement');
                            this.is_processing = false;
                        });
                        return true;
                    }
                    alert('Sorry, an error occurred');
                    this.is_processing = false;
                    return false;

                }).catch((e) => {
                    if(e.response){
                        console.log(e.response.data.message);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                    this.is_processing = false;
                });
            }
        },
        cloneLastMonth()
        {
            if(confirm("This will clear all your scheduled workouts for the shown month (if any exist), and clone your schedule from the previous month. Continue?"))
            {
            	this.is_processing = true;

                axios.post(`/api/user/clone-last-month/${this.month}/${this.year}`).then((response)=>{

                    if(response.data.success)
                    {
                        this.getData(this.month, this.year).then(()=>{
                            this.$store.commit('syncPlacedVideosList', response.data.placed_vimeo_ids_list);
                            this.$store.commit('resetVideoPlacement');
                            this.is_processing = false;
                        });
                        return true;
                    }
                    alert('Sorry, an error occurred');
                    this.is_processing = false;
                    return false;

                }).catch((e) => {
                    if(e.response){
                        console.log(e.response.data.message);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                    this.is_processing = false;
                });
            }
        },
        alternateBookMoves() {
          if (confirm("This will clear your current programme & divide your training into a 50 / 50 split between library routines and ‘the book on video’ routines. Continue?")) {
            this.is_processing = true;

          axios.post(`/api/user/alternate-book-moves`).then((response) => {

              if (response.data.success) {
                this.getData(this.month, this.year).then(() => {
                  this.$store.commit('syncPlacedVideosList', response.data.placed_vimeo_ids_list);
                  this.$store.commit('resetVideoPlacement');
                  this.is_processing = false;
                });
                return true;
              }
              alert('Sorry, an error occurred');
              this.is_processing = false;
              return false;

            }).catch((e) => {
              if (e.response) {
                console.log(e.response.data.message);
              } else {
                throw new Error('An error occurred connecting with the server.');
              }
              this.is_processing = false;
            });
          }
        },
        openCalendarModal()
        {
        	emitter.emit('calendarModalOpening');
        }
    },
    computed: {
        calendar_mode: {
            get() { return this.$store.getters.getCalendarMode },
            set(mode) {
                this.$store.commit('setCalendarMode', mode);
            }
        },
    },
    watch: {
	    '$store.state.main_data': function(updated_data){
		    if(updated_data.hasOwnProperty('calendar_data')){
		    	this.setMonth(updated_data.calendar_data.month, updated_data.calendar_data.year);
                this.applyMonth(updated_data.calendar_data);
                this.default_to_book = updated_data.calendar_data.default_to_book;
            }
	    }
    }
}

</script>
